<template>
  <v-footer
    :fixed="fixedFooter"
    :inset="!fixedFooter"
    :class="[!footer ? 'hide' : '', navFooterScheme]"
    app
  >
    <!--<div class="pa-3">-->
      <!--&copy; {{ new Date().getFullYear() }} Dealer Knows, All rights reserved.-->
    <!--</div>-->
    <v-spacer></v-spacer>
    <div class="pa-3">Powered by TaskTeacher</div>
  </v-footer>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      fixedFooter: "fixedFooter",
      footer: "showFooter",
      navFooterScheme: "navFooterScheme"
    })
  }
};
</script>
